import React from "react";
import { useTheme } from "@mui/styles";
import { Typography, Box, useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    mt: { xs: "79px", md: "-58px", lg: "-83px", xl: "-125px" },
    display: "flex",
    flexDirection: { xs: "column" },
    justifyContent: "center",
    width: { md: "750px", lg: "970px", xl: "1455px" },
    boxShadow: { md: "0 4px 100px 0 rgba(199, 206, 211, 0.25)" },
    borderRadius: { md: "47px" },
    height: { md: "200px", lg: "218px", xl: "327px" },
    alignItems: { md: "center" },
    bgcolor: { md: theme.palette.white.main },
  },
  text: {
    fontSize: { xs: "23px", md: "15px", lg: "17px", xl: "27px" },
    lineHeight: { xs: "40px", md: "30px", lg: "34px", xl: "50px" },
    color: theme.palette.blue.main,
    fontFamily: theme.typography.montserrat.regular,
    width: { xs: "308px", md: "607px", lg: "924px", xl: "1205px" },
    textAlign: { xs: "center" },
  },
  span: {
    fontWeight: "bold",
  },
  dots: {
    position: "absolute",
    width: "100%",
    transform: "translate(0, 65px)",
  },
});

const CodingChallengeText = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const { description, img } = useTranslation(pathname, "CodingChallengeText");

  return (
    <>
      <Box sx={classes.container}>
        <Typography sx={classes.text}>
          <b>
            {description[0]}
            <br></br>
            {description[1]}
          </b>
        </Typography>
        {isMobile ? null : (
          <img src={img.src} alt={img.alt} style={classes.dots} />
        )}
      </Box>
    </>
  );
};

export default CodingChallengeText;
